import { getReasonPhrase } from 'http-status-codes';

export interface AppErrorModel<T = unknown> {
  status: number;
  statusText: string;
  context: string;
  data?: T;
}

export class AppError<T = unknown> extends Error implements AppErrorModel<T> {
  public constructor(
    public readonly status: number,
    public readonly statusText: string,
    public readonly context: string,
    public readonly data?: T,
  ) {
    super(`${context}: ${statusText}`);
  }

  public static create<T>(context: string, status: number, data?: T): AppError<T> {
    return new AppError(status, AppError.getReason(status), context, data);
  }

  public static createFromModel<T>(data: AppErrorModel<T>): AppError<T> {
    return new AppError(data.status, data.statusText, data.context, data.data);
  }

  private static getReason(status: number): string {
    try {
      return getReasonPhrase(status);
    } catch {
      return 'unknown reason';
    }
  }

  public override toString(): string {
    return `${this.message} - ${this.serializeData()}`;
  }

  private serializeData(): string {
    return (typeof this.data !== 'object') ? String(this.data) : JSON.stringify(this.data);
  }
}
